import { assetCareFormDefinition } from './assetCareFormDef';
import { nationwideFormDefinition } from './nationwideFormDef';
import {
  assetCareUnderwritingForm,
  nationwideUnderwritingForm,
} from './formMetadata';
import {
  assetCareApplicationForm,
  careScoutApplicationForm,
  nationwideApplicationForm,
} from './applicationFormMetadata';

import { nationwideCareMattersFormDefinition } from '@shared/application-form/nationwide/nationwideAppFormDef';
import { nationwideCareMattersSDFormDefinition } from '@shared/application-form/nationwide/nationwideAppSDFormDef';
import { nationwideCareMattersNJFormDefinition } from '@shared/application-form/nationwide/nationwideAppNJFormDef';
import { nationwideCareMattersCAFormDefinition } from '@shared/application-form/nationwide/nationwideAppCAFormDef';
import { nationwideCareMattersNDFormDefinition } from '@shared/application-form/nationwide/nationwideAppNDFormDef';
import { nationwideCareMattersINFormDefinition } from '@shared/application-form/nationwide/nationwideAppINFormDef';
import { nationwideCareMattersFLFormDefinition } from '@shared/application-form/nationwide/nationwideAppFLFormDef';
import { nationwideCareMattersDEFormDefinition } from '@shared/application-form/nationwide/nationwideAppDEFormDef';
import { nationwideCareMattersDCFormDefinition } from '@shared/application-form/nationwide/nationwideAppDCFormDef';
import { nationwideCareMattersCTFormDefinition } from '@shared/application-form/nationwide/nationwideAppCTFormDef';
import { nationwideCareMattersAZFormDefinition } from '@shared/application-form/nationwide/nationwideAppAZFormDef';
import { nationwideCareMattersSCFormDefinition } from '@shared/application-form/nationwide/nationwideAppSCFormDef';

import { oneAmericaAssetCareFormDef } from '@shared/application-form/one-america/oneAmericaAppFormDef';
import { oneAmericaAssetCareFLFormDef } from '@shared/application-form/one-america/oneAmericaAppFLFormDef';
import { oneAmericaAssetCareCAFormDef } from '@shared/application-form';

import { careScoutFormDefinition } from '@shared/application-form';
import { careScoutAZFormDefinition } from '@shared/application-form/care-scout/careScoutAppAZForm';
import { careScoutCTFormDefinition } from '@shared/application-form/care-scout/careScoutAppCTForm';
import { careScoutDCFormDefinition } from '@shared/application-form/care-scout/careScoutAppDCForm';
import { careScoutDEFormDefinition } from '@shared/application-form/care-scout/careScoutAppDEForm';
import { careScoutILFormDefinition } from '@shared/application-form/care-scout/careScoutAppILForm';
import { careScoutKSFormDefinition } from '@shared/application-form/care-scout/careScoutAppKSForm';
import { careScoutMDFormDefinition } from '@shared/application-form/care-scout/careScoutAppMDForm';
import { careScoutNDFormDefinition } from '@shared/application-form/care-scout/careScoutAppNDForm';
import { careScoutORFormDefinition } from '@shared/application-form/care-scout/careScoutAppORForm';
import { careScoutSCFormDefinition } from '@shared/application-form/care-scout/careScoutAppSCForm';
import { careScoutSDFormDefinition } from '@shared/application-form/care-scout/careScoutAppSDForm';
import { careScoutTXFormDefinition } from '@shared/application-form/care-scout/careScoutAppTXForm';
import { careScoutVTFormDefinition } from '@shared/application-form/care-scout/careScoutAppVTForm';
import { careScoutWIFormDefinition } from '@shared/application-form/care-scout/careScoutAppWIForm';

const oneAmericaForms: PolicyFormLookup = {
  [assetCareUnderwritingForm.formId]: {
    formDefinition: assetCareFormDefinition,
    formMetadata: assetCareUnderwritingForm,
    stateCode: 'default',
    name: "OneAmerica AssetCare Underwriting Form",
  },
  [assetCareApplicationForm.default.formId]: {
    formDefinition: oneAmericaAssetCareFormDef,
    formMetadata: assetCareApplicationForm.default,
    stateCode: 'default',
    name: "OneAmerica AssetCare Application Form",
  },
  [assetCareApplicationForm.CA.formId]: {
    formDefinition: oneAmericaAssetCareCAFormDef,
    formMetadata: assetCareApplicationForm.CA,
    stateCode: 'CA',
    name: "OneAmerica AssetCare Application Form CA",
  },
  [assetCareApplicationForm.FL.formId]: {
    formDefinition: oneAmericaAssetCareFLFormDef,
    formMetadata: assetCareApplicationForm.FL,
    stateCode: 'FL',
    name: "OneAmerica AssetCare Application Form FL",
  },
};

const nationwideForms: PolicyFormLookup = {
  [nationwideUnderwritingForm.formId]: {
    formDefinition: nationwideFormDefinition,
    formMetadata: nationwideUnderwritingForm,
    stateCode: 'default',
    name: "Nationwide Care Matters II Underwriting Form",
  },
  [nationwideApplicationForm.default.formId]: {
    formDefinition: nationwideCareMattersFormDefinition,
    formMetadata: nationwideApplicationForm.default,
    stateCode: 'default',
    name: "Nationwide Care Matters II Application Form",
  },
  [nationwideApplicationForm.AZ.formId]: {
    formDefinition: nationwideCareMattersAZFormDefinition,
    formMetadata: nationwideApplicationForm.AZ,
    stateCode: 'AZ',
    name: "Nationwide Care Matters II Application Form AZ",
  },
  [nationwideApplicationForm.CA.formId]: {
    formDefinition: nationwideCareMattersCAFormDefinition,
    formMetadata: nationwideApplicationForm.CA,
    stateCode: 'CA',
    name: "Nationwide Care Matters II Application Form CA",
  },
  [nationwideApplicationForm.CT.formId]: {
    formDefinition: nationwideCareMattersCTFormDefinition,
    formMetadata: nationwideApplicationForm.CT,
    stateCode: 'CT',
    name: "Nationwide Care Matters II Application Form CT",
  },
  [nationwideApplicationForm.DC.formId]: {
    formDefinition: nationwideCareMattersDCFormDefinition,
    formMetadata: nationwideApplicationForm.DC,
    stateCode: 'DC',
    name: "Nationwide Care Matters II Application Form DC",
  },
  [nationwideApplicationForm.DE.formId]: {
    formDefinition: nationwideCareMattersDEFormDefinition,
    formMetadata: nationwideApplicationForm.DE,
    stateCode: 'DE',
    name: "Nationwide Care Matters II Application Form DE",
  },
  [nationwideApplicationForm.FL.formId]: {
    formDefinition: nationwideCareMattersFLFormDefinition,
    formMetadata: nationwideApplicationForm.FL,
    stateCode: 'FL',
    name: "Nationwide Care Matters II Application Form FL",
  },
  [nationwideApplicationForm.IN.formId]: {
    formDefinition: nationwideCareMattersINFormDefinition,
    formMetadata: nationwideApplicationForm.IN,
    stateCode: 'IN',
    name: "Nationwide Care Matters II Application Form IN",
  },
  [nationwideApplicationForm.ND.formId]: {
    formDefinition: nationwideCareMattersNDFormDefinition,
    formMetadata: nationwideApplicationForm.ND,
    stateCode: 'ND',
    name: "Nationwide Care Matters II Application Form ND",
  },
  [nationwideApplicationForm.NJ.formId]: {
    formDefinition: nationwideCareMattersNJFormDefinition,
    formMetadata: nationwideApplicationForm.NJ,
    stateCode: 'NJ',
    name: "Nationwide Care Matters II Application Form NJ",
  },
  [nationwideApplicationForm.SC.formId]: {
    formDefinition: nationwideCareMattersSCFormDefinition,
    formMetadata: nationwideApplicationForm.SC,
    stateCode: 'SC',
    name: "Nationwide Care Matters II Application Form SC",
  },
  [nationwideApplicationForm.SD.formId]: {
    formDefinition: nationwideCareMattersSDFormDefinition,
    formMetadata: nationwideApplicationForm.SD,
    stateCode: 'SD',
    name: "Nationwide Care Matters II Application Form SD",
  },
};

const careScoutForms: PolicyFormLookup = {
  [careScoutApplicationForm.default.formId]: {
    formDefinition: careScoutFormDefinition,
    formMetadata: careScoutApplicationForm.default,
    stateCode: 'default',
    name: "CareScout Application Form",
  },
  [careScoutApplicationForm.AZ.formId]: {
    formDefinition: careScoutAZFormDefinition,
    formMetadata: careScoutApplicationForm.AZ,
    stateCode: 'AZ',
    name: "CareScout Application Form AZ",
  },
  [careScoutApplicationForm.CT.formId]: {
    formDefinition: careScoutCTFormDefinition,
    formMetadata: careScoutApplicationForm.CT,
    stateCode: 'CT',
    name: "CareScout Application Form CT",
  },
  [careScoutApplicationForm.DC.formId]: {
    formDefinition: careScoutDCFormDefinition,
    formMetadata: careScoutApplicationForm.DC,
    stateCode: 'DC',
    name: "CareScout Application Form DC",
  },
  [careScoutApplicationForm.DE.formId]: {
    formDefinition: careScoutDEFormDefinition,
    formMetadata: careScoutApplicationForm.DE,
    stateCode: 'DE',
    name: "CareScout Application Form DE",
  },
  [careScoutApplicationForm.IL.formId]: {
    formDefinition: careScoutILFormDefinition,
    formMetadata: careScoutApplicationForm.IL,
    stateCode: 'IL',
    name: "CareScout Application Form IL",
  },
  [careScoutApplicationForm.KS.formId]: {
    formDefinition: careScoutKSFormDefinition,
    formMetadata: careScoutApplicationForm.KS,
    stateCode: 'KS',
    name: "CareScout Application Form KS",
  },
  [careScoutApplicationForm.MD.formId]: {
    formDefinition: careScoutMDFormDefinition,
    formMetadata: careScoutApplicationForm.MD,
    stateCode: 'MD',
    name: "CareScout Application Form MD",
  },
  [careScoutApplicationForm.ND.formId]: {
    formDefinition: careScoutNDFormDefinition,
    formMetadata: careScoutApplicationForm.ND,
    stateCode: 'ND',
    name: "CareScout Application Form ND",
  },
  [careScoutApplicationForm.OR.formId]: {
    formDefinition: careScoutORFormDefinition,
    formMetadata: careScoutApplicationForm.OR,
    stateCode: 'OR',
    name: "CareScout Application Form OR",
  },
  [careScoutApplicationForm.SC.formId]: {
    formDefinition: careScoutSCFormDefinition,
    formMetadata: careScoutApplicationForm.SC,
    stateCode: 'SC',
    name: "CareScout Application Form SC",
  },
  [careScoutApplicationForm.SD.formId]: {
    formDefinition: careScoutSDFormDefinition,
    formMetadata: careScoutApplicationForm.SD,
    stateCode: 'SD',
    name: "CareScout Application Form SD",
  },
  [careScoutApplicationForm.TX.formId]: {
    formDefinition: careScoutTXFormDefinition,
    formMetadata: careScoutApplicationForm.TX,
    stateCode: 'TX',
    name: "CareScout Application Form TX",
  },
  [careScoutApplicationForm.VT.formId]: {
    formDefinition: careScoutVTFormDefinition,
    formMetadata: careScoutApplicationForm.VT,
    stateCode: 'VT',
    name: "CareScout Application Form VT",
  },
  [careScoutApplicationForm.WI.formId]: {
    formDefinition: careScoutWIFormDefinition,
    formMetadata: careScoutApplicationForm.WI,
    stateCode: 'WI',
    name: "CareScout Application Form WI",
  },
};

export const policyFormDefs: PolicyFormLookup = {
  ...oneAmericaForms,
  ...nationwideForms,
  ...careScoutForms,
};
